module.exports = __webpack_public_path__ + "media/theme/1 open (1)-08c28de8.png";